import { render, staticRenderFns } from "./GraphDetail21.vue?vue&type=template&id=33c87e77&scoped=true"
import script from "./GraphDetail21.vue?vue&type=script&lang=js"
export * from "./GraphDetail21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c87e77",
  null
  
)

export default component.exports